<template>
  <div class="s-professionalInfoConsultationBuyTea-contianer">
    <topNav></topNav>
    <div class="s-information-top">
      <div class="banner w1300 marginAuto"></div>
    </div>
    <div class="content w1300 marginAuto">
      <div class="crumbs">
        <img src="../assets/image/index/home.png" class="img" alt />
        <span @click="crumbsGoRoute('index')" class="go">首页&gt;</span>
        <span @click="crumbsGoRoute('professionalInfoConsultation')" class="go">农资采集&gt;</span>
        <span>产品介绍</span>
      </div>
      <div class="s-professionalInfoConsultationBuyTea-list" v-if="buyTeaData.length > 0">
        <div
          class="s-professionalInfoConsultationBuyTea-item"
          v-for="(item,index) in buyTeaData"
          :key="index"
        >
          <div class="s-professionalInfoConsultationBuyTea-top">
            <div class="s-professionalInfoConsultationBuyTea-img">
              <img :src="urlImg == null ? normalImgUrl:urlImg +'/'+item.commodityImage" alt />
            </div>

            <div class="s-professionalInfoConsultationBuyTea-right">
              <div class="product-detial-title" style="width: 100%">
                <p @click="goHref(enterpriseData.enterpriseLink)"> {{item.productName}}</p>

                <span class="tea-schedule-btn" @click="scheduleDialogBtn(item.id)">茶叶预定</span>
              </div>

              <div class="product-detial-content">
                <div class="product-detial-info">
                  <div class="specifications">
                    <span class="span-title">规格：</span>
                    {{item.productSpeci || '--'}}g
                  </div>
                  <div class="price">
                    <span class="span-title">价格：</span>
                    <span class="span-icon">￥</span>
                    {{item.price || '--'}}元
                  </div>
                  <div class="logistics">
                    <span class="span-title">支持物流：</span>
                    {{item.logisticsCompany || '--'}}
                    <el-button size="mini" class="logisticsCompany-btn" @click="logisticsCompanyBtn">物流查询</el-button>
                  </div>
                </div>

                <div class="product-detial">
                  <div class="detail-title">产品详情：</div>
                  <div class="product-detial-list">
                    <div class="product-detial-list_flex product-detial-list_flex1">
                      <div
                        class="product-detial-list-item"
                        :title="item.productionLicense"
                      >生产许可证编号:{{item.productionLicense}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.productStandardNummber"
                      >产品标准号:{{item.productStandardNummber}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.factoryName"
                      >厂名:{{item.factoryName}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.factoryAddress"
                      >厂址:{{item.factoryAddress}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.phone"
                      >厂家联系方式:{{item.phone}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.ingredientsList"
                      >配料表:{{item.ingredientsList}}</div>
                    </div>
                    <div class="product-detial-list_flex">
                      <div
                        class="product-detial-list-item"
                        :title="item.placeOrigin"
                      >产地:{{item.placeOrigin}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.province"
                      >省份:{{item.province}}</div>
                      <div class="product-detial-list-item" :title="item.city">城市:{{item.city}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.workmanship"
                      >食品工艺:{{item.workmanship}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.packingType"
                      >包装方式:{{item.packingType}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.netContent"
                      >净含量:{{item.netContent}}g</div>
                    </div>
                  </div>
                  <div class="product-detial-list">
                    <div class="product-detial-list_flex product-detial-list_flex1">
                      <div
                        class="product-detial-list-item"
                        :title="item.teaType"
                      >茶种类:{{item.teaType}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.levelNum"
                      >级别:{{item.levelNum}}</div>
                      <div class="product-detial-list-item" :title="item.season">季节:{{item.season}}</div>
                      <div class="product-detial-list-item" :title="item.scene">场景:{{item.scene}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.intended"
                      >适用人群:{{item.intended}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.storageMethod"
                      >储藏方法:{{item.storageMethod}}</div>
                    </div>
                    <div class="product-detial-list_flex">
                      <div
                        class="product-detial-list-item"
                        :title="item.qualityGuarantee"
                      >保质期: {{item.qualityGuarantee}}</div>
                      <div
                        class="product-detial-list-item"
                        :title="item.foodAdditive"
                      >食品添加剂:{{item.foodAdditive}}</div>
                      <div class="product-detial-list-item" :title="item.brand">品牌:{{item.brand}}</div>
                      <div class="product-detial-list-item" :title="item.series">系列:{{item.series}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--          -->
        </div>
      </div>
      <div class="s-professionalInfoConsultationBuyTea-list" v-else>
        <div class="no-data">暂无数据！</div>
      </div>
    </div>
    <footer-nav></footer-nav>

    <!--茶叶预定-->
    <el-dialog
      title="茶叶预定信息"
      :visible.sync="scheduleDialog"
      width="40%"
      :before-close="scheduleDialogClose"
      class="transactionsReleaseDialog"
    >
      <div class="transactions-release-body">
        <el-form ref="scheduleRef" :model="scheduleForm" :rules="scheduleRules" label-width="100px">
          <el-form-item label="姓名" class="transactions-form-item" prop="customerName">
            <el-input v-model.trim="scheduleForm.customerName" maxlength="20" clearable></el-input>
          </el-form-item>

          <el-form-item label="数量" class="transactions-form-item" prop="buyCount">
            <el-input v-model.trim="scheduleForm.buyCount" type="number" maxlength="10" clearable></el-input>
          </el-form-item>

          <el-form-item label="手机号" class="transactions-form-item" prop="phone">
            <el-input v-model.trim="scheduleForm.phone" maxlength="11" clearable></el-input>
          </el-form-item>

          <el-form-item label="收货地址" class="transactions-form-item" prop="receiveAddress">
            <el-input v-model.trim="scheduleForm.receiveAddress" maxlength="20" clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="transactions-release-footer">
          <div class="transactions-release-close" @click="scheduleDialogClose">取消</div>
          <div class="transactions-release-sure" @click="submitSchedule">发布</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topNav from "../components/topNav.vue";
import footerNav from "../components/footerNav.vue";
import {
  teaPurchaseDetail,
  submitSchedule
} from "../utils/api/professionalInfoConsultation";
import Vue from "vue";
import validate from "@/utils/js/validator";
import { addMatchUp } from "@/utils/api/dealmakers";
export default {
  name: "professionalInfoConsultationBuyTea",
  data() {
    return {
      id: "",
      enterpriseData: {},
      buyTeaData: [
        // {
        //   imgUrl: require("../assets/image/professionalInfoConsultation/buyTea/titleImg.png"),
        //   title: "国企 富春·绿茶 通版 烘青工艺 福安绿茶 早春",
        //   specifications: "250g",
        //   price: "520.00"
        // },
        // {
        //   imgUrl: require("../assets/image/professionalInfoConsultation/buyTea/titleImg.png"),
        //   title: "国企 富春·绿茶 通版 烘青工艺 福安绿茶 早春",
        //   specifications: "250g",
        //   price: "520.00"
        // },
        // {
        //   imgUrl: require("../assets/image/professionalInfoConsultation/buyTea/titleImg.png"),
        //   title: "国企 富春·绿茶 通版 烘青工艺 福安绿茶 早春",
        //   specifications: "250g",
        //   price: "520.00"
        // }
      ],
      urlImg: Vue.prototype.imgURL,
      normalImgUrl: require("../assets/image/professionalInfoConsultation/teaConsulting/enterprise.png"),
      scheduleDialog: false, //茶叶预定弹窗
      scheduleForm: {
        commodityListId: "",
        customerName: "",
        buyCount: "",
        phone: "",
        receiveAddress: ""
      },
      scheduleRules: {
        customerName: [
          { required: true, message: "请输入名字", trigger: "blur" }
        ],
        buyCount: [
          { required: true, message: "请输入预测数量", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().priceProp,
            trigger: "blur"
          }
        ],
        phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            validator: validate.FormValidate.Form().validatePhone,
            trigger: "blur"
          }
        ],
        receiveAddress: [
          { required: true, message: "请输入收货地址", trigger: "blur" }
        ]
      },
      commodityListId: ""
    };
  },
  components: { topNav, footerNav },
  created() {},
  mounted() {
    this.id = this.$route.query.id;
    this.teaPurchaseDetail();
  },
  methods: {
    goHref(href){
      window.open(href)
    },
    crumbsGoRoute(path) {
      this.$router.push({ path,query:{currentTab:"农资采集"} });
    },
    // 详情
    async teaPurchaseDetail() {
      let res = await teaPurchaseDetail({ id: this.id });
      if (res.data.code == 0) {
        this.enterpriseData = res.data.data.enterprise;
        this.buyTeaData = res.data.data.list;
      }
    },

    //茶叶预定 打开弹窗
    scheduleDialogBtn(id) {
      this.scheduleDialog = true;
      this.commodityListId = id;
      this.$nextTick(() => {
        this.$refs["scheduleRef"].resetFields();
      });
    },
    //茶叶预定 关闭弹窗
    scheduleDialogClose() {
      this.scheduleDialog = false;
    },

    //茶叶预定 弹窗内容提交
    async submitSchedule() {
      this.$refs["scheduleRef"].validate(async valid => {
        if (valid) {
          if (JSON.parse(this.$store.state.isLogin)) {
            this.scheduleForm.commodityListId = this.commodityListId;
            let res = await submitSchedule(this.scheduleForm);
            if (res.data.code == 0) {
              this.scheduleDialog = false;
              this.scheduleForm = {};
            }
          } else {
            return this.$message({
              type: "warning",
              message: "请先登录!"
            });
          }
        } else {
          return false;
        }
      });
    },
    //物流查询
    logisticsCompanyBtn(){
      window.location.href = "https://www.baidu.com/s?word=%E5%BF%AB%E9%80%92%E6%9F%A5%E8%AF%A2&tn=site888_2_pg&ch=3&lm=-1&ssl_s=2&ssl_c=ssl1_18a2ab7623b&ie=utf-8";
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../utils/css/common.scss";
@import "../utils/css/professionalInfoConsultationBuyTea.scss";
</style>
<style lang="scss">
.transactionsReleaseDialog {
  .el-dialog {
    margin-top: 25vh !important;
  }
  .el-dialog__footer {
    text-align: left !important;
  }
}
</style>
